export function applyContentOverrides(root, settings, pathname) {
  if (!root) return () => {};
  const media = new Map((settings.media_replacements || []).filter(x => x.source_image && (x.image !== x.source_image || x.alt || x.enabled === false)).map(x => [x.source_image, x]));
  const texts = (settings.text_replacements || []).filter(x => x.enabled !== false && x.original?.trim() && (x.page === '*' || x.page === pathname));
  if (!media.size && !texts.length) return () => {};
  const images = new Map(), nodes = new Map();
  let frame;
  const attributes = ['src', 'srcset', 'sizes', 'alt', 'hidden'];
  const set = (el, key, value) => { if (value === null) el.removeAttribute(key); else if (el.getAttribute(key) !== value) el.setAttribute(key, value); };
  const run = () => {
    observer.disconnect();
    root.querySelectorAll('img').forEach(el => {
      let state = images.get(el);
      // If React changes a reused image, treat it as a fresh source.
      if (state && el.getAttribute('src') !== state.appliedSrc) { images.delete(el); state = null; }
      const original = state?.original || Object.fromEntries(attributes.map(key => [key, el.getAttribute(key)]));
      const rule = media.get(original.src);
      if (!rule) return;
      if (!state) { state = {original}; images.set(el, state); }
      if (rule.enabled === false || !rule.image) set(el, 'hidden', '');
      else {
        set(el, 'src', rule.image); set(el, 'srcset', null); set(el, 'sizes', null);
        set(el, 'hidden', original.hidden);
        if (rule.alt) set(el, 'alt', rule.alt);
      }
      state.appliedSrc = el.getAttribute('src');
    });
    if (texts.length) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style,textarea,input,select,[contenteditable],.admin-shell,[role="status"],[role="alert"]')) continue;
        let state = nodes.get(node);
        if (state && node.nodeValue !== state.applied) { nodes.delete(node); state = null; }
        const original = state?.original ?? node.nodeValue;
        const rule = texts.find(x => x.original.trim() === original.trim());
        if (!rule) continue;
        const next = original.replace(original.trim(), rule.replacement || '');
        if (next !== original) { nodes.set(node, {original, applied:next}); node.nodeValue = next; }
      }
    }
    observer.observe(root, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['src','srcset','alt']});
  };
  const observer = new MutationObserver(() => { cancelAnimationFrame(frame); frame = requestAnimationFrame(run); });
  run();
  return () => {
    observer.disconnect(); cancelAnimationFrame(frame);
    images.forEach(({original, appliedSrc}, el) => { if (el.getAttribute('src') === appliedSrc) attributes.forEach(key => set(el, key, original[key])); });
    nodes.forEach(({original, applied}, node) => { if (node.nodeValue === applied) node.nodeValue = original; });
  };
}
